import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import formatNumber from 'venuescanner-js/helpers/formatNumber';
import Chip, { chipClasses } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import cls from 'classnames';

const EnquiryInfoItem = ({ children, ...props }) => {
  const { title, value, isCurrency, hasLink, bold } = props;
  const { activeCurrency } = useContext(ViewContext);

  if (!value && !children) {
    return null;
  }

  return (
    <div
      className={cls('enquiry-info-item', { 'enquiry-info-item--bold': bold })}>
      <p className='enquiry-info-item__title'>{title}</p>
      <div
        className={cls('enquiry-info-item__value', {
          'enquiry-info-item__value--ccy': isCurrency,
        })}>
        {value && (
          <>
            {isCurrency && activeCurrency && (
              <span className='enquiry-info-item__ccy'>
                {activeCurrency.currency.symbol}
              </span>
            )}
            {hasLink ? (
              <a href={hasLink} target='_blank' rel='noreferrer'>
                <p className='enquiry-info-item__title'>{value}</p>
              </a>
            ) : (
              <p>{isCurrency ? formatNumber(value) : value}</p>
            )}
          </>
        )}
        {children}
      </div>
    </div>
  );
};

const EnquiryInfoItems = ({ children }) => (
  <div className='enquiry-info-container'>{children}</div>
);

const EnquiryInfoChip = styled(Chip)(({ theme }) => ({
  height: 'auto',

  [`& .${chipClasses.label}`]: {
    color: theme.palette.common.white,
    fontSize: theme.typography.subtitle2.fontSize,
    paddingTop: 8,
    paddingBottom: 8,
  },
}));

const EnquiryInfoChipItem = ({ title, value }) => {
  return (
    <div className='enquiry-info-item'>
      <p className='enquiry-info-item__title'>{title}</p>
      <div className='enquiry-info-item__value'>
        <EnquiryInfoChip color='supportiveDarkGreen' label={value} />
      </div>
    </div>
  );
};

EnquiryInfoChipItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export { EnquiryInfoItem, EnquiryInfoItems, EnquiryInfoChipItem };
